export default "__VITE_ASSET__01440461__"